import type { ScriptDoc } from './config';

interface RootShape {
  root?: { children?: unknown };
}

/** True when `value` has the minimal shape of a Lexical SerializedEditorState
 *  (`root.children` is an array) — the same gate the server applies before it
 *  touches a doc. Anything else (a pre-doc-JSON markdown draft, a bare string,
 *  a truncated payload) is not a script doc and must not reach the editor. */
export function isScriptDoc(value: unknown): value is ScriptDoc {
  if (typeof value !== 'object' || value === null) return false;
  const root = (value as RootShape).root;
  if (typeof root !== 'object' || root === null) return false;
  return Array.isArray(root.children);
}
